import { getSiteUrl, titleFormat } from "@repo/shared"
import { useLocale } from "next-intl"
import { useMemo } from "react"

import { AnnouncementItem } from "../../../../servers/newscenter/interface"

/**
 * 公告详情路径 Hook
 * @description 根据公告信息生成详情页路径
 * @param announcement 公告项
 * @returns 详情页路径
 */
export function useAnnouncementDetailPath(announcement: AnnouncementItem | undefined) {
  const locale = useLocale()

  const detailPath = useMemo(() => {
    if (!announcement) {
      return ""
    }

    const urlFriendlyTitle = titleFormat(announcement.title ?? "", { lower: true })

    return `${getSiteUrl("www")}/${locale}/announcements/${announcement.id}-${urlFriendlyTitle}`
  }, [announcement, locale])

  return detailPath
}
